module.exports = __webpack_public_path__ + "img/Isolated_Growler_Icon.c44fe824.png";